export const DISCLAIMER_TEXT =
  "sanskariBazarIn is a private community networking and business discovery platform. The platform does not promote caste hatred, caste superiority, discrimination, exclusion, or bias based on caste, creed, color, religion, gender, region, or nationality. The platform exists only for community networking, business discovery, cultural connection, and mutual support. All users must follow local laws and respectful conduct.";

export const PAGE_SIZES = [50, 75, 100, 150];

export const THEMES = [
  { id: "sunny", label: "Sunny Day", dot: "#ea7a1c", className: "theme-sunny" },
  { id: "darknight", label: "Darknight", dot: "#0a0a0a", className: "theme-darknight" },
  { id: "evening", label: "Soothing Evening", dot: "#38bdf8", className: "theme-evening" },
];
